import { Component, OnInit, NgZone, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-add-geofence',
  templateUrl: './add-geofence.component.html',
  styleUrls: ['./add-geofence.component.css']
})
export class AddGeofenceComponent implements OnInit {
  // @Output() geofenceRadius: any = new EventEmitter();
  // @Input() geofenceRadius:number;
  public geofenceRadius: number = 1;
  @ViewChild('modalHide') modalHide;

  public addGeofenceForm: FormGroup;
  public addGeofenceFormSubmitted: boolean = false;
  public branchLocation = {};
  public selectedValueClose = false;
  public locationSuggestions = {};
  public radiusCnt: number = 1
  primaryMap: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  markerId = 'branchLocation';
  formSubmit: boolean = false;
  public selectedMap: string = 'osrm';
  public disableLocation: boolean = true;
  public branchInformation: any = [];
  public selectedVehicle: any = [];

  //geofence
  public isMultipleGeo: boolean = false;

  //radius error
  public isRadiusGreater: boolean = false;
  public radiusError: string = '';
  public vehiclelists: any = [];
  vehiclelistsBackup: any;
  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public ngZone: NgZone,
    private fb: FormBuilder) {
    let user = this.storage.get('userInfo');
    if (user && user.map) {
      this.selectedMap = user.map;
    }
  }
  get f(): { [key: string]: AbstractControl } {
    return this.addGeofenceForm.controls;
  }

  ngOnInit(): void {
    this.addBranchLoad();
    this.getBranchList();
    this.getListVehicle();
    if (this.selectedMap == 'google') {
      setTimeout(() => {
        let radius = document.getElementById("radius");
        if (radius != null) {
          radius.addEventListener("keypress", function (evt) {
            if (evt.key == '-' || evt.key == ' ' || evt.key == '+') {
              evt.preventDefault();
            }
          });
        }
      }, 100)
    }
  }
  addBranchLoad() {
    this.addGeofenceForm = this.fb.group({
      branch: ['', [Validators.required]],
      radius: ['1', [Validators.required]],
      location: ['', [Validators.required]],
      title: ['', [Validators.required, Validators.pattern(/^([A-Za-z0-9 ])+(?:\.[a-zA-Z0-9]+?)*$/)]],
      vehicles: ['', [Validators.required]],
      isEnable: ['true', [Validators.required]],
    });
  }
  formatName() {
    let title = this.addGeofenceForm.value.title.replace(/ {2,}/g, ' ').trim();
    this.addGeofenceForm.patchValue({
      title: title
    })
  }
  /* checking error in fields*/

  public checkError = (controlName: string, errorName: string) => {
    return this.addGeofenceForm.controls[controlName].hasError(errorName);
  }
  radiusValidation() {
    this.geofenceRadius = this.addGeofenceForm.value.radius;
    let radiusField = document.getElementById('radiusField');
    if (this.addGeofenceForm.value.radius <= 25 && this.addGeofenceForm.value.radius > 0 && this.addGeofenceForm.value.radius != null) {
      this.isRadiusGreater = false;
      radiusField.classList.remove('mat-form-field-invalid');
      radiusField.classList.remove('ng-invalid');
      radiusField.classList.add('ng-valid');
      this.radiusError = '';
    } else if (this.addGeofenceForm.value.radius == null) {
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.isRadiusGreater = false;
      this.radiusError = '';
    } else if (this.addGeofenceForm.value.radius == 0) {
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.radiusError = 'Radius must be above 0KM';
      this.isRadiusGreater = true;
    } else {
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.radiusError = 'Radius limits upto 25KM';
      this.isRadiusGreater = true;
    }
  }

  getLocation(obj) {
    this.branchLocation = { ...obj };
  }
  /* Cancel Add branch*/

  cancel() {
    this.router.navigate(['/organization/transport-manager/information/orgInfo/geofence/view-geofence']);
  }

  getSelectedLocation(obj) {
    this.branchLocation = { ...obj };
    if (this.branchLocation && this.branchLocation['name'] && this.branchLocation['name'] != '') {
      this.addGeofenceForm.patchValue({
        location: this.branchLocation['name']
      })
    }
  }
  /* submit data*/
  onSubmit() {
    this.formSubmit = true;
    this.addGeofenceFormSubmitted = true;
    // if(this.selectedMap=='google'){
    //   this.radiusValidation();
    // }
    if (this.addGeofenceForm.valid && this.selectedMap != 'google' || this.addGeofenceForm.valid && this.selectedMap == 'google' && !this.isRadiusGreater) {
      const obj = {
        ...this.addGeofenceForm.value
      };

      delete obj.location;
      obj.location = this.branchLocation;
      obj.radius = +obj.radius;
      obj.isEnable = convertStringToBoolean(obj.isEnable);

      function convertStringToBoolean(value: string) {
        return value === 'true';
      }
      this.api.transportManagerGeofenceCreate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/geofence/view-geofence'])

        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });

    } else {
      this.addGeofenceForm.markAllAsTouched();
    }
  }
  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && res.data.length > 0) {
          res.data.filter((e) => {
            let option = { name: e.branchName, value: e.branchID };
            this.branchInformation.push(option);
          });
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getListVehicle() {
    const obj = {
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehiclelists = res.data;
        this.vehiclelistsBackup = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getVehicleResult(value, event) {
    //  this.selectedVehicle = value;
  }
  getName(id, data, key, returnValue) {
    let result = '';
    if (!Array.isArray(data)) data = [data];
    data.filter((item) => {
      if (item[key] == id) {
        result = item[returnValue];
      }
    })
    return result;
  }

}
